import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import styled from 'styled-components';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`

const AMreadonlyrow = ({k,onChangeSub, row,onClickAddSubCateg, onClickEdit,handleDeleteClick,
   page, rowsPerPage,tableFontSize, editCategor, subCateg, SubmitButton}) =>{
    
    return(        
        <>
         <TableRow key={k} name={row.categ}>
            <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}} align="left">
            {(page)*(rowsPerPage)+k+1}
            </TableCell>
         <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
          {row?.Category}
         </TableCell>
        <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
          <Autocomplete
              disablePortal
              id="combo-box-demo"
              size='small'
              value={subCateg[`subcateg${(page)*(rowsPerPage)+k}`]?.data?.length? subCateg[`subcateg${(page)*(rowsPerPage)+k}`].data :null}
              onChange={(event, newValue)=>onChangeSub(event, newValue, `subcateg${(page)*(rowsPerPage)+k}`,k)}
              options={row?.Asset?.map(x => x.Name)}
              sx={{backgroundColor:"white", width:"200px", height:"40px"}}
              renderInput={(params) => <TextField {...params} label={"Select Asset"} />}
           />
        </TableCell>
            <TableCell align="left" sx={{ fontSize: tableFontSize}}>
              <ButtonWrapper>
                <SubmitButton type='button' style={{backgroundColor:"#ed6c02", color:"lightgreen", height:"35px", margin:"0px"}} onClick ={(e)=>onClickEdit(e,k,subCateg[`subcateg${(page)*(rowsPerPage)+k}`])}>Edit</SubmitButton>
                <SubmitButton type='button' style={{backgroundColor:"#D32F2F", color:"lightgreen", height:"35px"}}  onClick ={(e)=>handleDeleteClick(e,k, row._id)}>Delete</SubmitButton>
                <SubmitButton type='button' style={{height:"35px"}}  onClick={(e)=>onClickAddSubCateg(e,k)}>Add Asset</SubmitButton>
              </ButtonWrapper>
            </TableCell>
          </TableRow>     
        </>        
    )
}

export default AMreadonlyrow;